var uniglovesVersion = 2;
var unigloves = {
    'comparisons': [],
    'favourites': []
};

jQuery(document).ready(function($){

    /**
     * Create a persistent 'unigloves' object using localStorage 
     */
    function get_unigloves(){
        if (localStorage.getItem("unigloves_"+uniglovesVersion) === null) {
            set_unigloves();
        }else{
            unigloves = JSON.parse(localStorage["unigloves_"+uniglovesVersion]);
        }
    }
    get_unigloves();

    /**
     * Update the unigloves object 
     */
    function set_unigloves(){
        localStorage["unigloves_"+uniglovesVersion] = JSON.stringify(unigloves);
        return true;
    }

    /**
     * Log object to console 
     */
    console.log(unigloves);

    /**
     * Add product to compare list
     */
    $('body').on('click', 'a[data-compare-add]', function(e){
        e.preventDefault();
        if(!unigloves.comparisons.includes($(this).data('compare-add'))){
            unigloves.comparisons.push($(this).data('compare-add'));
        }
        set_unigloves();
        $(this).prop('href','/pages/compare')
        .text('View comparisons')
        .removeAttr('data-compare-add');
    });

    /**
     * Remove product from compare list
     */
    $('body').on('click', 'a[data-compare-remove]', function(e){
        e.preventDefault();
        var remove_product = $(this).data('compare-remove');
        if(unigloves.comparisons.includes($(this).data('compare-remove'))){
            unigloves.comparisons.forEach(function (item, index) {
                if(item == remove_product){
                    unigloves.comparisons.splice(index, 1);
                }
            });
        }
        set_unigloves();
        $(this).closest('.product-comparison').parent().remove();
        window.scrollTo(0, 0);
    });

    /**
     * Add product to favourites list
     */
    $('a[data-favourite-add]').click(function(e){
        e.preventDefault();
        if(!unigloves.favourites.includes($(this).data('favourite-add'))){
            unigloves.favourites.push($(this).data('favourite-add'));
        }
        set_unigloves();
        $(this).text('Added');
    });

    /**
     * Equal height cards
     */
     $(window).on("load resize", function(e) {
        var max_height = 0;
        $('.article-card .title').css('min-height', 0).each(function() {
            if ($(this).outerHeight() > max_height) max_height = $(this).outerHeight();
        }).css('min-height', max_height + 'px');

        var max_height = 0;
        $('.product-card .image').css('min-height', 0).each(function() {
            if ($(this).outerHeight() > max_height) max_height = $(this).outerHeight();
        }).css('min-height', max_height + 'px');

       var max_height = 0;
        $('.product-card .features').css('min-height', 0).each(function() {
            if ($(this).outerHeight() > max_height) max_height = $(this).outerHeight();
        }).css('min-height', max_height + 'px');


    });
 

});